module.exports = __webpack_public_path__ + "static/media/bv.07434a84.svg";